/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 8/1/19
 * Time: 10:56 AM
 */
import React, {Component} from 'react';
import {Col, Row} from "reactstrap";
import './Details.css'
import LabelDropdown from "../../../../../components/Dropdown/LabelDropdown/LabelDropdown";
import {Button as SementicBtn, Button, Checkbox, Icon, Segment} from "semantic-ui-react";
import building_icon from "../../../../../assets/img/recept_checkin/building.svg";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import floor_icon from "../../../../../assets/img/recept_checkin/floor.svg";
import Cookies from "js-cookie";
import axios from "../../../../../axios/axios_visitortag";
import pass_icon from "../../../../../assets/img/recept_checkin/pass.svg";
import * as common from "../../../../../const/Common/CommonFunc";
import {Empty} from "antd";
import LabelInput from "../../../../../components/Input/LabelInput/LabelInput";
import DatePicker from "react-datepicker/es";
import wifi_icon from "../../../../../assets/img/recept_checkin/wifi.svg";
import uuid from "uuid";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import success_icon from "../../../../../assets/img/sweet/success.svg";
import error_icon from "../../../../../assets/img/sweet/cry.svg";
import VisitorPhotoUpload from "../../../../../components/VisitorPhotoUpload/VisitorPhotoUpload";
import apiConfig from "../../../../../axios/axios_api_services";
import moment from "moment";
import $ from "jquery";
import {withTranslation} from "react-i18next";

class App extends Component {

  state = {
    decription: 'Searching meeting data...',
    meeting_building: '',
    meeting_building_id: '',
    meeting_original_building_id: '',
    meeting_floor: '',
    meeting_original_floor: '',
    meeting_pass_no: '',
    meeting: null,

    hostA_id: 0,
    hostB_id: 0,
    meetingVisitorId: 0,

    isWifi: false,
    selectedDate: new Date().setDate(new Date().getDate() + 1),
    wifi_package: 0,
    wifi_expire_date: '',
    visitor_purpose: '',
    isHostB: false,

    location: '',
    screenshot: '',
  };

  screenshotHandler = (screenshot) => {
    this.setState({
      screenshot: screenshot
    });
  };
  componentWillMount(){

  }

  proceed = () => {

    let {visitor_purpose, meeting_floor, meeting_pass_no, hostA_id, hostB_id, meetingVisitorId, wifi_package, wifi_expire_date} = this.state;

    if (hostA_id === 0 || meetingVisitorId === 0) {
      common.notifyMessage("Denied to access - Invalid Details");
    } else {
      if (meeting_pass_no === '' || meeting_floor === '' || visitor_purpose === null || visitor_purpose === "") {
        this.state.meeting_floor === '' ? common.notifyMessage("please enter floor") :
          this.state.meeting_pass_no === '' ? common.notifyMessage("please enter card") :
            common.notifyMessage("please select visitor purpose");

      } else {
        if (this.state.isWifi) {
          if (this.state.wifi_package === 0 || this.state.wifi_expire_date === '') {
            common.notifyMessage("please enter wifi package details");
          } else {
            if(this.state.isHostB){
              if(hostB_id === 0){
                common.notifyMessage("please select host B");
              }else{
                this.warningMessage()
              }
            }else{
              this.warningMessage()
            }

          }
        } else {
          if(this.state.isHostB){
            if(hostB_id === 0){
              common.notifyMessage("please select host B");
            }else{
              this.warningMessage()
            }
          }else{
            this.warningMessage()
          }
        }
      }
    }
  };
  handleExpireDate = (e) => {
    let date = this.convertDate(e);
    this.setState({
      selectedDate: new Date(e).getTime(),
      wifi_expire_date: date
    });
  };
  convertDate = (date) => {
    let d = new Date(date);
    d = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2) + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2);
    return d;
  };
  wifiOnChange = (e, {value}) => {
    this.setState({
      wifi_package: value
    });
  };

  buildingOnChange = (e, {value}) => {
    let selectedBuilding = this.props.all_building_list[value];
    const floor_options = [];

    if (selectedBuilding.floors.length !== 0) {
      selectedBuilding.floors.map((element, index) => {
        floor_options.push({
          key: element.floor_id,
          text: element.description,
          value: element.floor_id,
          image: {avatar: true, src: floor_icon},
        })
      })
    }

    this.setState({
      meeting_floor: "",
      meeting_building: value,
      meeting_building_id: selectedBuilding.buildingId
    });
    this.props.receptionAllFloorHandler(floor_options);
  };

  buildingChangeUsingId = (id) => {
    let all_building_list = this.props.all_building_list;
    let index_ = '';
    const floor_options = [];

    if(all_building_list.length !== 0 ){
      all_building_list.map((building,index)=>{
        if(building.buildingId === id){
          index_ = index;

          if (building.floors.length !== 0) {
            building.floors.map((element, index) => {
              floor_options.push({
                key: element.floor_id,
                text: element.description,
                value: element.floor_id,
                image: {avatar: true, src: floor_icon},
              })
            })
          }
        }
      })
    }

    this.setState({
      meeting_building: index_,
      meeting_building_id: id,
      meeting_original_building_id: id
    });
    this.props.receptionAllFloorHandler(floor_options);
  };

  floorOnChange = (e, {value}) => {
    this.setState({
      meeting_floor: value
    });
  };
  passOnChange = (e, {value}) => {
    this.setState({
      meeting_pass_no: value
    });
  };

  sendToBackend = () => {
    let {visitor_purpose, meeting_floor, meeting_pass_no, hostA_id, hostB_id, meetingVisitorId, wifi_package, selectedDate,screenshot} = this.state;

    this.props.spinnerHandler(true);
    const obj = {
      meetingVisitorId: meetingVisitorId,
      hostA: hostA_id,
      hostB: hostB_id,
      floorId: meeting_floor,
      cardId: meeting_pass_no,
      visitingPurpose: visitor_purpose,
      wifi: {
        wifipackageId: wifi_package,
        expireDate: selectedDate,
      },
      photoPath: screenshot
    };

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    axios.post(apiConfig.CORPORATE_MEETING_CREATE(corporateId), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.props.callAllCount(this.props.usr_obj);
          swal({
            title: "Meeting successfully saved",
            icon: success_icon,
            closeOnClickOutside: false,
            buttons: {
              dangerMode: {
                text: "Okay",
                value: "action",
                className: "okay-btn"
              }
            }
          })
            .then((value) => {
              switch (value) {
                case "action":
                  this.props.closeModal();
                  break;
                default:
                  this.props.closeModal();
              }
            })

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };

  warningMessage = () => {
    const {t} = this.props;
    swal({
      title: t('do_you_want_to_schedule_meeting?'),
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: t('cancel'),
        dangerMode: {
          text: t('yes'),
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.sendToBackend();
            break;
          default:
        }
      });
  };

  fillingData = () => {
    let data = this.props.result.content;
    this.setState({
      hostA_id: data.meeting.host1 === null ? 0 : data.meeting.host1.userId,
      hostB_id: data.meeting.host2 === null ? 0 : data.meeting.host2.userId,
      meetingVisitorId: data.mvId,
      meeting_pass_no: this.props.result.isCard ? this.props.result.meeting_pass_no : '',
      visitor_purpose: data.meeting.meetingPurpose,
      screenshot: data.userEntity.photoPath,

      meeting: {
        hostA: data.meeting.host1 === null ? "-" : data.meeting.host1.firstName + " " + data.meeting.host1.lastName,
        hostA_mobile: data.meeting.host1 === null ? "-" : data.meeting.host1.mobile,
        hostA_ext: data.meeting.host1 === null ? "-" : data.meeting.host1.extention !== null ? data.meeting.host1.extention : "-",
        hostA_designation: data.meeting.host1 === null ? "-" : data.meeting.host1.designation !== null ? data.meeting.host1.designation : "-",
        hostA_department: data.meeting.host1 === null ? "-" : data.meeting.host1.department !== null ? data.meeting.host1.department : "-",

        hostB: data.meeting.host2 === null ? "-" : data.meeting.host2.firstName + " " + data.meeting.host2.lastName,
        hostB_mobile: data.meeting.host2 === null ? "-" : data.meeting.host2.mobile,
        hostB_ext: data.meeting.host2 === null ? "-" : data.meeting.host2.extention !== null ? data.meeting.host2.extention : "-",
        hostB_designation: data.meeting.host2 === null ? "-" : data.meeting.host2.designation !== null ? data.meeting.host2.designation : "-",
        hostB_department: data.meeting.host2 === null ? "-" : data.meeting.host2.department !== null ? data.meeting.host2.department : "-",

        visitor_identify: data.userEntity.identificationValue === null ? "-" : data.userEntity.identificationValue,
        visitor_title: data.userEntity.title === null ? "-" : data.userEntity.title,
        visitor_fname: data.userEntity.firstName === null ? "-" : data.userEntity.firstName,
        visitor_lname: data.userEntity.lastName === null ? "-" : data.userEntity.lastName,
        visitor_mobile: data.userEntity.mobile === null ? "-" : data.userEntity.mobile,
        visitor_company: data.userEntity.companyName === null ? "-" : data.userEntity.companyName,
        visitor_email: data.userEntity.email === null ? "-" : data.userEntity.email,

        visitor_purpose: data.meeting.meetingPurpose === null ? "" : data.meeting.meetingPurpose,

        location: data.meeting.location === null ? "-" : data.meeting.location,
        schedule_datetime: data.meeting.scheduleDate ?  moment(data.meeting.scheduleDate).format('YYYY-MM-DD hh:mm A') : "-"
      },
      meeting_floor: data.floorId ? data.floorId: '',
      meeting_original_floor: data.floorId ? data.floorId: ''
    });
    if(data.buildingId){
      this.buildingChangeUsingId(data.buildingId);
    }
  };

  handleSearchHost = (e, {searchQuery}) => {
    if (searchQuery.trim().length > 2) {
      if (searchQuery.trim().length === 3) {
        this.setState({
          host_loader: true,
          coporate_host: []
        });

        const headers = {
          "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
        };

        let coperateId = this.props.usr_obj.corporates[0].corporateId;
        let coporate_host = [];

        // Get Host Details From Name Suggestions
        axios.get(apiConfig.CORPORATE_HOST_SEARCH({corporateId:coperateId,searchValue:searchQuery.trim()}), {headers: headers})
          .then(response => {
            if (response.data.success) {
              let data = response.data.hostList;

              if (data.length !== 0) {
                data.map((host, index) => {
                  let host_mobile = searchQuery.startsWith("94") ? host.mobile.startsWith("0") ? host.mobile.split("0").join('94'):host.mobile:host.mobile;
                  let empId = host.empId !== null && host.empId !== "" ? " - "+host.empId : "";
                  let text = host_mobile + " - " + host.firstName + " " + host.lastName + empId;
                  let data = {
                    ...host,
                    key: index,
                    text: text,
                    value: uuid(),
                  };
                  coporate_host.push(data)
                });
              }
            }

            this.setState({
              host_loader: false,
              coporate_host: coporate_host
            })
          })
          .catch(async error => {
            let result = await common.checkErrorResponse(error);
            if (result === 1) {
              this.handleSearchHost(e, {searchQuery});
            }
          });
      }
    } else {
      this.setState({coporate_host: [], host_loader: false})
    }
  };
  handleSelectHost = (e, {value}) => {
    let data = this.state.coporate_host;

    let selectedHost = null;
    data.map((host, index) => {
      if (host.value === value) {
        selectedHost = host;
      }
    });

    let userId = selectedHost.userId;
    let name = selectedHost.firstName + " " + selectedHost.lastName;
    let mobile = selectedHost.mobile === null || selectedHost.mobile === undefined ? "-" : selectedHost.mobile;
    let extention = selectedHost.extention === null || selectedHost.extention === undefined ? "-" : selectedHost.extention;
    let department = selectedHost.department === null || selectedHost.department === undefined ? "-" : selectedHost.department.name;
    let designation = selectedHost.designation === null || selectedHost.designation === undefined ? "-" : selectedHost.designation;

    let meeting_obj = this.state.meeting;
    meeting_obj.hostB = name;
    meeting_obj.hostB_mobile = mobile;
    meeting_obj.hostB_ext = extention;
    meeting_obj.hostB_designation = designation;
    meeting_obj.hostB_department = department;

    this.setState({
      hostB_id: userId,
      meeting: meeting_obj
    })
  };
  purposeOnChange = (e, {value}) => {
    this.setState({
      visitor_purpose: value
    });
  };

  componentDidMount() {
    this.fillingData();
    let date = this.convertDate(new Date().setDate(new Date().getDate() + 1));
    this.setState({
      wifi_expire_date: date
    });
  }

  toggleHostB = () => {
    let meeting_obj = this.state.meeting;
    meeting_obj.hostB = "";
    meeting_obj.hostB_mobile = "";
    meeting_obj.hostB_ext = "";
    meeting_obj.hostB_designation = "";
    meeting_obj.hostB_department = "";
    this.setState({
      isHostB: !this.state.isHostB,
      meeting: meeting_obj,
      hostB_id: 0
    })
  };

  render() {
    const {t} = this.props;
    let {meeting_original_floor, meeting_floor,meeting_original_building_id, meeting_building_id} = this.state;
    if(meeting_floor !== meeting_original_floor){
      $('.recept-uIerL-floor-drop').css('background-color', '#ffd7d7');
    }else{
      $('.recept-uIerL-floor-drop').css('background-color', '#ffffff');
    }

    if(meeting_original_building_id !== meeting_building_id){
      $('.recept-uIerL-building-drop').css('background-color', '#ffd7d7');
    }else{
      $('.recept-uIerL-building-drop').css('background-color', '#ffffff');
    }
    let all_building_list = this.props.all_building_list;
    let floor_options = this.props.all_floor_list;
    let pass_options = this.props.all_available_card;
    let screenshot = this.state.screenshot;

    const building_options = [];

    if (all_building_list.length !== 0) {
      all_building_list.map((element, index) => {
        building_options.push({
          key: index,
          text: element.name,
          value: index,
          image: {avatar: true, src: building_icon},
        })
      })
    }

    const wifi_pacakge_options = [];
    if (this.props.all_wifi_packages_list.length !== 0) {
      this.props.all_wifi_packages_list.map((element, index) => {
        wifi_pacakge_options.push({
          key: element.packageId,
          text: element.name,
          value: element.packageId,
          image: {avatar: true, src: wifi_icon},
        })
      })
    }
    return (
      <div>
        {
          this.state.meeting !== null ?
            <Row className={"details-main-div"}>
              <Col md={12}>
                <Row className={"col-details-wrapper"}>
                  <Col md={6} className={"col-details part-1"}>
                    <div className={"segment-view"}>
                      <h1 className={"title-segment"}>{t('request_host_-_(host_A)')}</h1>
                      <p>{t('requested_host') + ": " + this.state.meeting.hostA}</p>
                      <p>{t('mobile') + ": " + this.state.meeting.hostA_mobile}</p>
                      <p>{t('extension') + ": " + this.state.meeting.hostA_ext}</p>
                      <p>{t('designation') + ": " + this.state.meeting.hostA_designation}</p>
                      <p>{t('department') + ": " + this.state.meeting.hostA_department}</p>
                    </div>

                    <div className={"segment-view"}>
                    <h1 className={"title-segment"}>{t('meeting_details')}</h1>
                      <p>{t('location') + ": " + this.state.meeting.location}</p>
                      <p>{t('schedule_date_&_time') + ": " + this.state.meeting.schedule_datetime}</p>
                    </div>

                    {
                      this.props.usr_obj.userRoles !== "EXTERNAL_RECEPTION" ?
                        <div className={"segment-view"}>
                          <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                    checked={this.state.isHostB}
                                    onChange={this.toggleHostB} toggle
                                    label={t('assign_other_staff_member')}/>
                          {
                            this.state.isHostB ?
                              <div>
                                <br/>
                                <LabelDropdown
                                  loading={this.state.host_loader}
                                  btnText={"Get Info"}
                                  tagText={t('staff_member')}
                                  placeholder={t('enter_name')}
                                  options={this.state.coporate_host}
                                  value={this.state.search_host}
                                  onSearchChange={this.handleSearchHost}
                                  onChange={this.handleSelectHost}

                                />
                                <p>{t('assign_to') + ": " + this.state.meeting.hostB}</p>
                                <p>{t('mobile') + ": " + this.state.meeting.hostB_mobile}</p>
                                <p>{t('extension') + ": " + this.state.meeting.hostB_ext}</p>
                                <p>{t('designation') + ": " + this.state.meeting.hostB_designation}</p>
                                <p>{t('department') + ": " + this.state.meeting.hostB_department}</p>
                              </div> : null
                          }

                        </div>:
                        this.state.isHostB &&
                        <div className={"segment-view"}>
                          <p>{t('assign_to') + ": " + this.state.meeting.hostB}</p>
                          <p>{t('mobile') + ": " + this.state.meeting.hostB_mobile}</p>
                          <p>{t('extension') + ": " + this.state.meeting.hostB_ext}</p>
                          <p>{t('designation') + ": " + this.state.meeting.hostB_designation}</p>
                          <p>{t('department') + ": " + this.state.meeting.hostB_department}</p>
                        </div>
                    }

                  </Col>
                  <Col md={6} className={"col-details part-2"}>
                    <div className={"segment-view"}>
                      <h1 className={"title-segment"}>{t('visitor_details')}</h1>

                      <p>{t('visitor_identity') + ": " + this.state.meeting.visitor_identify}</p>
                      <p>{t('title') + ": " + this.state.meeting.visitor_title}</p>
                      <p>{t('first_name') + ": " + this.state.meeting.visitor_fname}</p>

                      <p>{t('last_name') + ": " + this.state.meeting.visitor_lname}</p>
                      <p>{t('mobile') + ": " + this.state.meeting.visitor_mobile}</p>
                      <p>{t('company') + ": " + this.state.meeting.visitor_company}</p>
                      <p>{t('email') + ": " + this.state.meeting.visitor_email}</p>

                      <p>{t('visiting_purpose') + ": " + this.state.meeting.visitor_purpose}</p>
                      <p>{t('visitor_image') + ": "}</p>
                      <VisitorPhotoUpload screenshotHandler={this.screenshotHandler} screenshot={screenshot} style={{ marginTop: "40vh" }} />

                    </div>
                  </Col>
                </Row>
              </Col>

              <Col xs={12}>
                <Row className={"bottom-div"}>
                  <Col xs={"12"}>
                    {
                      this.state.meeting.visitor_purpose === null || this.state.meeting.visitor_purpose === "" ?
                        <LabelDropdown
                          required
                          lblFontSize={"12px"}
                          tagText={t('visiting_purpose')}
                          placeholder={t('select_visit_type')}
                          options={this.props.visitors_purpose_options_list}
                          onChange={this.purposeOnChange}
                        /> : null
                    }

                    <LabelDropdown
                      lblId={'building_details'}
                      required
                      className={"recept-uIerL-building-drop"}
                      tagText={t('building')}
                      placeholder={t('select_building')}
                      options={building_options}
                      onChange={this.buildingOnChange}
                      value={this.state.meeting_building}
                    />

                    <LabelDropdown
                      required
                      className={"recept-uIerL-floor-drop"}
                      tagText={t('floor')}
                      placeholder={t('select_floor')}
                      options={floor_options}
                      onChange={this.floorOnChange}
                      value={this.state.meeting_floor}
                    />

                    <LabelDropdown
                      lblId={'details_lblPassNumber'}
                      required
                      disable={this.props.result.isCard}
                      tagText={t('pass_number')}
                      placeholder={t('please_choose_from_above')}
                      options={pass_options}
                      value={this.state.meeting_pass_no}
                      onChange={this.passOnChange}
                    />

                  </Col>
                </Row>
                {/*wifi packages*/}

                {/*<div className={"button-div"}>*/}
                {/*<Checkbox*/}
                {/*style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important', marginBottom: '7px'}}*/}
                {/*checked={this.state.isWifi} onChange={() => this.setState({isWifi: !this.state.isWifi})} toggle*/}
                {/*label='Do you want to enable wifi'/>*/}
                {/*{*/}
                {/*this.state.isWifi ?*/}
                {/*<Row>*/}
                {/*<Col lg="6" md={"12"} sm={"12"} xs={"12"}>*/}
                {/*<LabelDropdown*/}
                {/*required={this.state.isWifi}*/}
                {/*tagText={"Wifi Package"}*/}
                {/*placeholder={"Select package"}*/}
                {/*options={wifi_pacakge_options}*/}
                {/*onChange={this.wifiOnChange}*/}
                {/*/>*/}
                {/*</Col>*/}

                {/*<Col lg="6" md={"12"} sm={"12"} xs={"12"}>*/}
                {/*<LabelInput*/}
                {/*disable*/}
                {/*required={this.state.isWifi}*/}
                {/*tagText={"Expire Date"}*/}
                {/*placeholder={"Please select date"}*/}
                {/*value={this.state.wifi_expire_date}*/}
                {/*/>*/}
                {/*<DatePicker*/}
                {/*inline*/}
                {/*selected={this.state.selectedDate}*/}
                {/*timeInputLabel="Choose Time"*/}
                {/*onChange={this.handleExpireDate}*/}
                {/*dateFormat="MM/dd/yyyy h:mm aa"*/}
                {/*showTimeInput*/}
                {/*minDate={new Date()}*/}
                {/*showDisabledMonthNavigation*/}
                {/*/>*/}
                {/*</Col>*/}
                {/*</Row>*/}
                {/*: null*/}
                {/*}*/}
                {/*</div>*/}

                <br/>
                <Row>
                  <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                    <Button className="px-5" onClick={this.proceed}>{t('proceed')}</Button>
                    {
                      this.props.usr_obj.userRoles === "EXTERNAL_RECEPTION" && <Button className="rmv-btn" onClick={this.props.closeModal}>{t('close')}</Button>
                    }
                  </Col>
                </Row>
              </Col>

            </Row> : <div style={{padding: '5%'}}>
              <Empty description={this.state.decription}/>
            </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  custom_visitors_list: state.reception_SheduleMeetingReducer.custom_visitors_list,
  visitors_purpose_options_list: state.reception_SheduleMeetingReducer.visitors_purpose_options_list,

  all_building_list: state.reception_SheduleMeetingReducer.all_building_list,
  all_wifi_packages_list: state.reception_SheduleMeetingReducer.all_wifi_packages_list,
  all_floor_list: state.reception_SheduleMeetingReducer.all_floor_list,
  all_available_card: state.reception_SheduleMeetingReducer.all_available_card,

  building_col: state.reception_SheduleMeetingReducer.building_col,
  visitors_col: state.reception_SheduleMeetingReducer.visitors_col,

  usr_obj: state.userReducer.user,
});
const mapDispatchToProps = (dispatch) => {
  return {
    callAllBuildings: (data) => dispatch(actionCreator.callAllBuildings(data)), // Get All Buildings Of Corporate
    callAllWifiPackages: (data) => dispatch(actionCreator.callAllWifiPackages(data)), // Get All Wifi Packges Of Corporate
    callAllCount: (data) => dispatch(actionCreator.callAllCount(data)), // Get All counts

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // reception meeting shedule handler
    receptionAddCustomVisitorsHandler: (data) => dispatch(actionCreator.receptionAddCustomVisitorsHandler(data)),

    // all floors
    receptionAllFloorHandler: (data) => dispatch(actionCreator.receptionAllFloorHandler(data)),
    // all building
    receptionAllBuildingHandler: (data) => dispatch(actionCreator.receptionAllBuildingHandler(data)),
    // all available cards
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));

